import { logger } from 'shared/infrastructure/logger';

import type { CrudErrorResponse } from 'core/utils/response';

// Textos que llegan como id cuando no hay job: `undefined`/`null` concatenados a la URL (DEU-548). `unknown` no está:
// el backend lo manda al alumno en los bloques Mint sin job y, con el curso y el ítem, crea el job al recibirlo
// (`frontStudentsJobs.js` de i2c_v2, 2026-10-29).
const PLACEHOLDER_JOB_GUIDS = new Set(['undefined', 'null']);

type InvalidJobGuidResponse = { error: CrudErrorResponse };

export function isValidJobGuid(jobGuid: unknown): jobGuid is string | number {
  if (typeof jobGuid === 'number') return Number.isInteger(jobGuid) && jobGuid > 0;
  if (typeof jobGuid !== 'string') return false;
  const trimmed = jobGuid.trim();
  return trimmed !== '' && !PLACEHOLDER_JOB_GUIDS.has(trimmed.toLowerCase());
}

function describeInvalidJobGuid(jobGuid: unknown): string {
  if (jobGuid === undefined) return 'undefined';
  if (jobGuid === null) return 'null';
  if (typeof jobGuid !== 'string') return typeof jobGuid;
  const trimmed = jobGuid.trim();
  return trimmed === '' ? 'empty' : trimmed.toLowerCase();
}

/**
 * Corta una petición a un job sin id. Resuelve con un `{ error }` como el del interceptor de axios (no lanza), así
 * que quien llama sigue el mismo camino que con el 404 que daba api-g (`crud.md`).
 */
export function rejectInvalidJobGuid(operation: string, jobGuid: unknown): Promise<InvalidJobGuidResponse> {
  logger.warn('Petición a un job sin id válido', {
    tags: { feature: 'jobs', operation, invalid_job_id: describeInvalidJobGuid(jobGuid) },
  });
  return Promise.resolve({ error: { status: 400 } });
}
